import select from './StaticMulSelect.vue'
const StaticMulSelect = {
	install: function(Vue) {
		Vue.component('StaticMulSelect', select)
	}
}
export default StaticMulSelect
